"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = info;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function info(window, _) {
  if (!console.table) {
    return function () {
      return console.log('Old browser');
    };
  }

  var TITLE = 'color:blue; font-weight:bold';

  var kb = function kb(bytes) {
    return bytes >> 10;
  };

  var totalTransferKb = function totalTransferKb(records) {
    return kb(_.reduce(records, function (result, _ref) {
      var transferSize = _ref.transferSize,
          encodedBodySize = _ref.encodedBodySize;
      return result + (transferSize || encodedBodySize);
    }, 0));
  };

  var transferred = function transferred(records) {
    return "".concat(records.length, " (").concat(totalTransferKb(records), " KB)");
  };

  var fixedNames = {
    2: 'First reLayout',
    3: 'Viewer Interactive',
    33: 'Page Interactive*',
    101: 'Page Navigation Start',
    103: 'Page Navigation Complete'
  };

  function fixStageName(entry) {
    var name = entry.name;
    var m = name.match(/\(beat (\d+)\)/);

    if (m) {
      var fixedName = fixedNames[m[1]];

      if (fixedName) {
        return _.assign({}, entry, {
          name: "".concat(fixedName, " ").concat(m[0])
        });
      }
    }

    return entry;
  }

  return function (verbose) {
    var getEntries = function getEntries(resourceType) {
      return function (filter) {
        return _(resourceType ? performance.getEntriesByType(resourceType) : performance.getEntries()).invokeMap('toJSON').filter(filter).value();
      };
    };

    var getResources = getEntries('resource');

    var getNavigation = function getNavigation() {
      return getEntries('navigation')(_.identity)[0];
    };

    var filterStages = function filterStages(_ref2) {
      var entryType = _ref2.entryType,
          name = _ref2.name;
      return entryType === 'paint' || entryType === 'mark' && (verbose || !/fedops|data-fixer-server|stylable|hydrate/.test(name));
    };

    var getStages = function getStages() {
      return _.map(getEntries()(filterStages), fixStageName);
    };

    function findImgElem(_ref3) {
      var initiatorType = _ref3.initiatorType,
          name = _ref3.name;

      switch (initiatorType) {
        case 'img':
          return document.querySelector("img[src=\"".concat(name, "\"]"));

        case 'css':
          return _.find(document.querySelectorAll('.pro-gallery canvas.gallery-item-visible'), function (el) {
            return getComputedStyle(el).getPropertyValue('background-image') === "url(\"".concat(name, "\")");
          });
      }
    }

    var document = window.document,
        navigator = window.navigator,
        performance = window.performance,
        getComputedStyle = window.getComputedStyle,
        wixBiSession = window.wixBiSession,
        santaBase = window.santaBase,
        boltBase = window.boltBase,
        clientSideRender = window.clientSideRender,
        timeSpentInSSR = window.timeSpentInSSR,
        santaRenderingError = window.santaRenderingError,
        rendererModel = window.rendererModel,
        _window$ssrInfo = window.ssrInfo,
        ssrInfo = _window$ssrInfo === void 0 ? {} : _window$ssrInfo;
    var dc = wixBiSession.dc,
        renderType = wixBiSession.renderType,
        caching = wixBiSession.caching,
        microPop = wixBiSession.microPop,
        wixBoltExclusionReason = wixBiSession.wixBoltExclusionReason,
        isUsingMesh = wixBiSession.isUsingMesh;
    console.log('%cSystem info', TITLE);
    var userAgent = navigator.userAgent,
        connection = navigator.connection,
        deviceMemory = navigator.deviceMemory;
    var system = {
      'User agent': userAgent
    };

    if (connection && connection.effectiveType) {
      system.Network = connection.effectiveType;
    }

    if (deviceMemory) {
      system['Memory (MB)'] = deviceMemory;
    }

    console.table(system);
    console.log('%cResources info', TITLE);
    var scripts = getResources(function (_ref4) {
      var initiatorType = _ref4.initiatorType,
          name = _ref4.name;
      return initiatorType === 'script' || /\.js$/.test(name);
    });
    var fonts = getResources(function (_ref5) {
      var initiatorType = _ref5.initiatorType,
          name = _ref5.name;
      return initiatorType === 'css' && /font/i.test(name);
    });
    var imgs = getResources(function (_ref6) {
      var initiatorType = _ref6.initiatorType,
          name = _ref6.name;
      return initiatorType === 'img' || initiatorType === 'css' && /\.(?:jpe?g|png|webp|gif)/i.test(name);
    });
    console.table({
      'Script protocol': scripts[0].nextHopProtocol,
      'Script files': transferred(scripts),
      'Fonts files': transferred(fonts),
      'Image files': transferred(imgs),
      'iframe count': document.querySelectorAll('iframe').length,
      'Comps count': document.querySelectorAll('#SITE_ROOT *[id^=comp-]').length,
      'Page length (screens)': Math.round(document.body.scrollHeight / document.body.offsetHeight)
    });
    var navigation = getNavigation();

    if (navigation) {
      console.log('%cResponse info', TITLE);
      var type = navigation.type,
          transferSize = navigation.transferSize,
          decodedBodySize = navigation.decodedBodySize,
          domainLookupStart = navigation.domainLookupStart,
          domainLookupEnd = navigation.domainLookupEnd,
          connectStart = navigation.connectStart,
          secureConnectionStart = navigation.secureConnectionStart,
          connectEnd = navigation.connectEnd,
          responseStart = navigation.responseStart,
          requestStart = navigation.requestStart;
      var HTMLserver = {
        'Load type': type,
        'Using DC': dc
      };

      if (microPop) {
        HTMLserver['Using micro-POP'] = microPop;
      }

      HTMLserver['Over the wire (KB)'] = kb(transferSize);
      HTMLserver['On client (KB)'] = kb(decodedBodySize);
      HTMLserver['DNS time'] = domainLookupEnd - domainLookupStart;

      if (secureConnectionStart) {
        HTMLserver['TCP handshake'] = secureConnectionStart - connectStart;
        HTMLserver['SSL handshake'] = connectEnd - secureConnectionStart;
      } else {
        HTMLserver['TCP handshake'] = connectEnd - connectStart;
      }

      HTMLserver['Request / response'] = responseStart - requestStart;
      console.table(_.mapValues(HTMLserver, function (v) {
        return _.isNumber(v) ? Math.round(v) : v;
      }));
    }

    console.log('%cTiming info', TITLE);
    var stages = getStages();

    if (navigation) {
      stages.push({
        name: 'TTFB',
        startTime: navigation.responseStart
      }, {
        name: 'HTML Loaded',
        startTime: navigation.responseEnd
      });
    }

    var interactive = _.find(stages, function (_ref7) {
      var name = _ref7.name;
      return name.includes('(beat 33)');
    }) || _.find(stages, function (_ref8) {
      var name = _ref8.name;
      return name.includes('(beat 3)');
    });

    if (interactive) {
      var lastVisibleImg = _(imgs).filter(function (_ref9) {
        var startTime = _ref9.startTime;
        return startTime < interactive.startTime;
      }).sortBy(function (_ref10) {
        var startTime = _ref10.startTime,
            duration = _ref10.duration;
        return -(startTime + (duration || 1000000));
      }).find(function (img) {
        var el = findImgElem(img);

        if (!el || el.hidden || getComputedStyle(el).opacity === '0') {
          return false;
        }

        var rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
      });

      if (lastVisibleImg) {
        stages.push({
          name: 'Visible Images Received*',
          startTime: lastVisibleImg.startTime + lastVisibleImg.duration
        });
      }
    }

    console.table(_(stages).sortBy('startTime').reduce(function (result, _ref11) {
      var name = _ref11.name,
          startTime = _ref11.startTime;
      result[name] = Math.round(startTime);
      return result;
    }, {}));
    console.log('%cSession info', TITLE);
    var clientSpecMap = rendererModel.clientSpecMap,
        metaSiteId = rendererModel.metaSiteId,
        landingPageId = rendererModel.landingPageId,
        _rendererModel$platfo = rendererModel.platformControllersOnPage,
        platformControllersOnPage = _rendererModel$platfo === void 0 ? {} : _rendererModel$platfo,
        pagesPlatformApplications = rendererModel.pagesPlatformApplications;

    var hasCorvid = _.get(pagesPlatformApplications, ['wixCode', landingPageId]);

    var platformApps = _.reduce(platformControllersOnPage[landingPageId], function (acc, value, key) {
      var spec = _.find(clientSpecMap, {
        appDefinitionId: key
      });

      return [].concat(_toConsumableArray(acc), [spec && spec.appDefinitionName || key]);
    }, hasCorvid ? ['Corvid'] : []);

    var isBolt = renderType === 'bolt';
    var version = isBolt ? boltBase : santaBase;
    var session = {
      'Metasite ID': "".concat(metaSiteId, " (").concat(landingPageId, ")"),
      'Version': "".concat(renderType, " (").concat(version.match(/\/([^/]+)$/)[1], ")")
    };

    if (!isBolt && wixBoltExclusionReason) {
      session['Bolt exclusion reason'] = wixBoltExclusionReason;
    }

    if (clientSideRender) {
      session['No SSR reason'] = santaRenderingError && santaRenderingError.errorInfo || 'Unknown';
    } else {
      var tssr = ssrInfo.timeSpentInSSR || timeSpentInSSR || 'unknown';
      session['SSR caching'] = "".concat(caching, " (").concat(tssr, ")");

      if (caching === 'none' && ssrInfo.cacheExclusionReason) {
        session['SSR no cache reason'] = ssrInfo.cacheExclusionReason;
      }
    }

    session['Using Mesh'] = !!isUsingMesh;

    if (platformApps.length) {
      session['Platform apps'] = platformApps.join();
    }

    console.table(session);
  };
}
//# sourceMappingURL=info.js.map